export const getSpiderTagsAndRows = (sourceData, defaultA, defaultB) => {
  const dataRows = [...sourceData];

  const tagsRowIndex = dataRows.findIndex((e) => e.customizeTags);
  const {
    tagA = defaultA || '-',
    tagB = defaultB || '-',
    tagC = 'category',
    tagD = 'comment',
  } = dataRows[tagsRowIndex] || {};

  if (tagsRowIndex > -1) {
    dataRows.splice(dataRows, 1);
  }

  return { dataRows, tagA, tagB, tagC, tagD };
};

export const getElementAbsPos = (e) => {
  let t = e.offsetTop;
  let l = e.offsetLeft;
  while ((e = e.offsetParent)) {
    t += e.offsetTop;
    l += e.offsetLeft;
  }

  return { left: l, top: t };
};
